import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  setThePerformsAgentRetrieveACtion,
  getSideBarfilesActions,
  setManpowerActivetabs,
  setTheNameFormForm,
  setthetotal_ids,
  settheStandardIDS,
  setTheListNamesactions,
  setThePutIdAnswerIds,
  setTheLastPerformanceIds,
  setTheLastObjectwithTotal_points,
  setTocalllRetrieve, //---reteiev funtions
  setThePerformsAgentEditACtion,
} from "../../../Redux/Slice";
import "../../../StyleSheet/MainComponent/Management/EmployeeProfile.scss";
import correctIcons from "../../../Assets/AppComponent/icons/Group 359.svg";
import Pending from "../../../Assets/AppComponent/icons/Group 145.svg";
import ArrowIcons from "../../../Assets/AppComponent/Arrow/Vector .svg";
import profile2 from "../../../Assets/AppComponent/Profile/profile2.png";
import { useNavigate } from "react-router-dom";
import { NavLink } from "react-router-dom";
import swal from "sweetalert2";
import Swal from "sweetalert2";
import emptycircle from "../../../Assets/AppComponent/Ellipse 4.png";
import { toast } from "react-toastify";
import BackImage from "../../../Assets/AppComponent/Overall_icons/UDS Needs Image-20.svg";


const ManPowerApply = () => {
  const stateDisplay = useSelector(
    (state) => state.SideBarActive.SidebarActive
  );

  const Swal = require("sweetalert2");
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const state = useSelector((state) => state);
  const [UserName, setUserName] = useState("");
  const [RoleName, setRoleNames] = useState();
  const [mappedst, setmappedts] = useState();
  console.log(state.ManPowerActiveDataTabs.EditIDs, "wqidhnqowid");
  useEffect(() => {
    if (state.ManPowerActiveDataTabs.EditIDs != "") {
      const payload = {
        EditId: state.ManPowerActiveDataTabs.EditIDs,
      };
      dispatch(setThePerformsAgentRetrieveACtion(payload));
    }
    ////--edit----setThePerformsAgentEditACtion,///---creata---setThePerformsAgentCreateACtion
  }, [state.ManPowerActiveDataTabs.EditIDs]);

  useEffect(() => {
    if (state.PerformsFieldAgentRetrieve.performsRetrieveData != undefined) {
      var total_id = [];
      var namelist = [];
      state.PerformsFieldAgentRetrieve.performsRetrieveData != undefined &&
        state.PerformsFieldAgentRetrieve.performsRetrieveData.perform_types !=
          undefined &&
        state.PerformsFieldAgentRetrieve.performsRetrieveData.perform_types !=
          null &&
        state.PerformsFieldAgentRetrieve.performsRetrieveData.perform_types
          .perform_id != undefined &&
        state.PerformsFieldAgentRetrieve.performsRetrieveData.perform_types
          .perform_id != null &&
        state.PerformsFieldAgentRetrieve.performsRetrieveData.perform_types.perform_id.map(
          (item) => {
            total_id.push(item.id);
            //  console.log(item.id  ,"sdcasyicgfa");
            namelist.push(item.grading_name);
          }
        );
      //  console.log(total_id ,"total_id");

      dispatch(setthetotal_ids(total_id));
      dispatch(setTheListNamesactions(namelist));
    }
    if (
      state.PerformsFieldAgentRetrieve.performsRetrieveData != undefined &&
      state.PerformsFieldAgentRetrieve.performsRetrieveData.perform_answer !=
        undefined &&
      state.PerformsFieldAgentRetrieve.performsRetrieveData.perform_answer !=
        null
    ) {
      console.log(
        state.PerformsFieldAgentRetrieve.performsRetrieveData.perform_answer,
        "performsRetrieveData"
      );

      Object.keys(
        state.PerformsFieldAgentRetrieve.performsRetrieveData.perform_answer
      ).map((innerKey, index) => {
        console.log(
          index,
          "asdaosudoouewqhr23u40923",
          innerKey,
          typeof innerKey
        );
        console.log(innerKey, "innsajdhasvderKey");

        state.PerformsFieldAgentRetrieve.performsRetrieveData != undefined &&
          state.PerformsFieldAgentRetrieve.performsRetrieveData.perform_types !=
            undefined &&
          state.PerformsFieldAgentRetrieve.performsRetrieveData.perform_types !=
            null &&
          state.PerformsFieldAgentRetrieve.performsRetrieveData.perform_types
            .perform_id != undefined &&
          state.PerformsFieldAgentRetrieve.performsRetrieveData.perform_types
            .perform_id != null &&
          state.PerformsFieldAgentRetrieve.performsRetrieveData.perform_types.perform_id.map(
            (item, index) => {
              if (
                innerKey ==
                item.grading_name
                  .toLowerCase()
                  .replace(/\s+/g, "_")
                  .replace(/[^a-z0-9_]/g, "_")
              )
                console.log(
                  innerKey ==
                    item.grading_name
                      .toLowerCase()
                      .replace(/\s+/g, "_")
                      .replace(/[^a-z0-9_]/g, "_"),
                  "transformedGradingName"
                );
            }
          );
        if (innerKey != undefined && typeof innerKey === "object") {
          dispatch(setTocalllRetrieve(true));
        } else {
          dispatch(setTocalllRetrieve(false));
        }
      });
    }
  }, [state.PerformsFieldAgentRetrieve.performsRetrieveData]);
  useEffect(() => {
    if (
      state.PerformsFieldAgentRetrieve.performsRetrieveData != undefined &&
      state.PerformsFieldAgentRetrieve.performsRetrieveData != null &&
      state.PerformsFieldAgentRetrieve.performsRetrieveData.perform_answer !=
        undefined &&
      state.PerformsFieldAgentRetrieve.performsRetrieveData.perform_answer !=
        null
    ) {

      dispatch(
        setThePutIdAnswerIds(
          state.PerformsFieldAgentRetrieve.performsRetrieveData.perform_answer
            .id
        )
      );
      //perform_answer

      ////---performance-----Last---Name---
      if (
        state.PerformsFieldAgentRetrieve.performsRetrieveData != undefined &&
        state.PerformsFieldAgentRetrieve.performsRetrieveData != null &&
        state.PerformsFieldAgentRetrieve.performsRetrieveData.perform_types !=
          null &&
        state.PerformsFieldAgentRetrieve.performsRetrieveData.perform_types !=
          undefined &&
        state.PerformsFieldAgentRetrieve.performsRetrieveData.perform_types
          .perform_id != undefined &&
        state.PerformsFieldAgentRetrieve.performsRetrieveData.perform_types
          .perform_id != null
      ) {
        state.PerformsFieldAgentRetrieve.performsRetrieveData.perform_types.perform_id.map(
          (item, index) => {
            console.log(
              index,
              item.grading_name,
              "sdiwedwie",
              state.PerformsFieldAgentRetrieve.performsRetrieveData
                .perform_types.perform_id.length - 1
            );
            if (
              index ==
              state.PerformsFieldAgentRetrieve.performsRetrieveData
                .perform_types.perform_id.length -
                1
            ) {
              console.log(item.grading_name, "gradingNamesxZXsad");
              /////---the----last---name----dispatch-
              dispatch(setTheLastPerformanceIds(item.grading_name));
            }
          }
        );
      }
    }
  }, [state.ManPowerActiveDataTabs.EditIDs]);

  ///----Next---last---objects----------
  var total_score = 0;

  useEffect(() => {
    if (
      state.PerformsFieldAgentRetrieve.performsRetrieveData != undefined &&
      state.PerformsFieldAgentRetrieve.performsRetrieveData != null &&
      state.PerformsFieldAgentRetrieve.performsRetrieveData.perform_answer !=
        undefined &&
      state.PerformsFieldAgentRetrieve.performsRetrieveData.perform_answer !=
        null
    ) {
      console.log(
        state.PerformsFieldAgentRetrieve.performsRetrieveData.perform_answer,
        "perform_answer"
      );
      var mappedOne = [];
      var to;
      Object.keys(
        state.PerformsFieldAgentRetrieve.performsRetrieveData.perform_answer
      ).map((innerKey, index) => {
        const value =
          state.PerformsFieldAgentRetrieve.performsRetrieveData.perform_answer[
            innerKey
          ];
        console.log(
          "value",
          innerKey,
          typeof innerKey,
          typeof value === "object"
        );

        if (value != null && value != undefined && typeof value === "object") {
          Object.entries(value).map(([subkey, subvalue], index) => {
            console.log(subkey, "subkeyiusdg", subvalue, index, innerKey);
            if (subkey == "total_points") {
              console.log("subvalue", subvalue);
              //   console.log({[innerKey ] : subvalue}, "hfgsdyfgsd");
              mappedOne.push({ [innerKey]: subvalue });

              setmappedts(mappedOne);
              console.log(mappedOne, "mappedOne");

              total_score += subvalue;
            }
          });
        }
      });
      console.log(mappedst, "mappedst");
      dispatch(setTheLastObjectwithTotal_points(mappedOne)); ////----the---header--name---and---total_points

      console.log(total_score, "tosdasdasdas");
    }
  }, [state.PerformsFieldAgentRetrieve.performsRetrieveData]);


  const HandleManPowerfunction = (item, index) => {
    console.log(item, index, "qwasdaud");
    dispatch(settheStandardIDS(item.id));
    dispatch(setTheNameFormForm(item.grading_name));
    dispatch(setManpowerActivetabs(index));

    if (item.id == state.ManPowerActiveDataTabs.Ids) {
      navigate("/assessmentrequest");
    }
  };
  const formatKey = (key) => {
    // Remove underscores and convert to lowercase
    let formattedKey = key.replace(/_/g, " ").toLowerCase();
    // Capitalize first letter of each word
    formattedKey = formattedKey.replace(/\b\w/g, (char) => char.toUpperCase());
    return formattedKey;
  };

  ///---for----decline----user----
  const HandleDecline = () => {
    Swal.fire({
      title: "Are you sure, do you want to Decline?",
      text: "You won't be able to revert this",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#234492",
      cancelButtonColor: "#6c757d",
      confirmButtonText: "Yes, Decline it!",
    }).then((result) => {
      if (result.isConfirmed) {
        const payload = {
          EditId:
            state.PerformsFieldAgentRetrieve.performsRetrieveData !=
              undefined &&
            state.PerformsFieldAgentRetrieve.performsRetrieveData != null &&
            state.PerformsFieldAgentRetrieve.performsRetrieveData
              .perform_answer != null &&
            state.PerformsFieldAgentRetrieve.performsRetrieveData
              .perform_answer != undefined &&
            state.PerformsFieldAgentRetrieve.performsRetrieveData.perform_answer
              .id != null &&
            state.PerformsFieldAgentRetrieve.performsRetrieveData.perform_answer
              .id != undefined
              ? state.PerformsFieldAgentRetrieve.performsRetrieveData
                  .perform_answer.id
              : "",
          innerdata: {
            status: "decline",
          },
        };
        dispatch(setThePerformsAgentEditACtion(payload));
        navigate("/manpower");
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        Swal.fire({
          // text: " Employee verification as been cancel",
          icon: "error",
        });
        Swal.close();
      }
    });
  };

  ////----for----verified----employees---
  const HandleVerify = () => {
    Swal.fire({
      title: "Are you sure, do you want to  Verify?",
      text: "You won't be able to revert this",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#234492",
      cancelButtonColor: "#6c757d",
      confirmButtonText: "Yes, Verify it!",
    }).then((result) => {
      if (
        result.isConfirmed &&
        state.PerformsFieldAgentRetrieve.performsRetrieveData != undefined &&
        state.PerformsFieldAgentRetrieve.performsRetrieveData != null &&
        state.PerformsFieldAgentRetrieve.performsRetrieveData.perform_answer !=
          null &&
        state.PerformsFieldAgentRetrieve.performsRetrieveData.perform_answer !=
          undefined &&
        state.PerformsFieldAgentRetrieve.performsRetrieveData.perform_answer
          .id != null &&
        state.PerformsFieldAgentRetrieve.performsRetrieveData.perform_answer
          .id != undefined &&
        state.PerformsFieldAgentRetrieve.performsRetrieveData.perform_answer
          .is_completed
      ) {
        const payload = {
          EditId:
            state.PerformsFieldAgentRetrieve.performsRetrieveData !=
              undefined &&
            state.PerformsFieldAgentRetrieve.performsRetrieveData != null &&
            state.PerformsFieldAgentRetrieve.performsRetrieveData
              .perform_answer != null &&
            state.PerformsFieldAgentRetrieve.performsRetrieveData
              .perform_answer != undefined &&
            state.PerformsFieldAgentRetrieve.performsRetrieveData.perform_answer
              .id != null &&
            state.PerformsFieldAgentRetrieve.performsRetrieveData.perform_answer
              .id != undefined
              ? state.PerformsFieldAgentRetrieve.performsRetrieveData
                  .perform_answer.id
              : "",
          innerdata: {
            status: "approved",
            user_id:state.ManPowerActiveDataTabs.EditIDs,
          },
        };
        dispatch(setThePerformsAgentEditACtion(payload));
        navigate("/manpower");
      } else if (
        state.PerformsFieldAgentRetrieve.performsRetrieveData != undefined &&
        state.PerformsFieldAgentRetrieve.performsRetrieveData != null &&
        state.PerformsFieldAgentRetrieve.performsRetrieveData.perform_answer !=
          null &&
        state.PerformsFieldAgentRetrieve.performsRetrieveData.perform_answer !=
          undefined &&
        state.PerformsFieldAgentRetrieve.performsRetrieveData.perform_answer
          .id != null &&
        state.PerformsFieldAgentRetrieve.performsRetrieveData.perform_answer
          .id != undefined &&
        !state.PerformsFieldAgentRetrieve.performsRetrieveData.perform_answer
          .is_completed
      ) {
        Swal.close();
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        Swal.close();
      }
    });
  };

  // {state.PerformsFieldAgentRetrieve.performsRetrieveData != undefined &&
  //   state.PerformsFieldAgentRetrieve.performsRetrieveData
  //     .perform_types != undefined &&
  //   state.PerformsFieldAgentRetrieve.performsRetrieveData
  //     .perform_types != null &&
  //   state.PerformsFieldAgentRetrieve.performsRetrieveData.perform_types
  //     .perform_id != undefined &&
  //   state.PerformsFieldAgentRetrieve.performsRetrieveData.perform_types
  //     .perform_id != null &&
  //   state.PerformsFieldAgentRetrieve.performsRetrieveData.perform_types.perform_id.map(
  //     (item, index) => {

  //       console.log(                                item.grading_name != undefined &&
  //         state.PerformsFieldAgentRetrieve
  //           .performsRetrieveData == undefined &&
  //         state.PerformsFieldAgentRetrieve
  //           .performsRetrieveData == null &&
  //         state.PerformsFieldAgentRetrieve
  //           .performsRetrieveData.perform_answer ==
  //           undefined &&
  //         state.PerformsFieldAgentRetrieve
  //           .performsRetrieveData.perform_answer == null
  //           ? emptycircle
  //           : (state.PerformsFieldAgentRetrieve
  //               .performsRetrieveData.perform_answer ==
  //               item.grading_name                  .toLowerCase()
  //               .replace(/\s+/g, "_")
  //               .replace(/[^a-z0-9_]/g, "_")) && state.PerformsFieldAgentRetrieve
  //               .performsRetrieveData.perform_answer != null

  //           ? "correct"
  //           : "pending" ,"pendinfsdfsoudc");

  //           console.log(state.PerformsFieldAgentRetrieve.performsRetrieveData.perform_answer ==
  //             item.grading_name                  .toLowerCase()
  //             .replace(/\s+/g, "_")
  //             .replace(/[^a-z0-9_]/g, "_") ,
  //             "osdjasjdkasdksad",

  //             item.grading_name,
  //             state.PerformsFieldAgentRetrieve.performsRetrieveData.perform_answer

  //             );

  //     }
  //   )}

  return (
    <>
      <div className={stateDisplay ? "outterContent" : "inner-Content"}>
        <div
          className="Header-Details ClientBranch row"
          style={{ padding: "14px 28px" }}
        >
          <div
            class="col-sm-7 auto"
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "flex-start",
              justifyContent: "flex-start",
            }}
          >
            <h3>Man Power Performance Apply </h3>
            {/* <ul class="breadcrumb">
              <li class="breadcrumb-item">
                <NavLink
                  style={{ textDecoration: "none", color: "#333333" }}
                  to={"/manpower"}
                  onClick={(e) => {
                    dispatch(getSideBarfilesActions("Man Power"));
                  }}
                >
                  Man Power Performance
                </NavLink>
              </li>
              <li class="breadcrumb-item">Man Power Performace Apply</li>
            </ul> */}
          </div>
        </div>



        <div
            className="row Filters ButtonPrevious"
            style={{
              padding: "15px 28px",
              margin: "0px",
              position: "relative",
              zIndex: "30",
              marginLeft: "0px",
              marginRight: "0px",
              top: "-30px",
            }}
            // style={{ marginLeft: "-17px" }}
          >
            <div className="col">
              <button
                className="btn BackImga"
                onClick={(e) => {
                  navigate("/manpower");
                }}
              >
                  <img  className="PreviousPages" src={BackImage}/>
                  <span></span>

              </button>
            </div>
          </div>




        <div className="Header-Details" style={{ marginTop: "20px" }}>
          <div className="InnerDetails">
            <div className="InnerDetailPart">
              <div className="LOGO">
                <img src={profile2} />
              </div>
              {state.PerformsFieldAgentRetrieve.performsRetrieveData !=
                undefined &&
              state.PerformsFieldAgentRetrieve.performsRetrieveData != null &&
              state.PerformsFieldAgentRetrieve.performsRetrieveData.user_id !=
                undefined &&
              state.PerformsFieldAgentRetrieve.performsRetrieveData.user_id !=
                null &&
              state.PerformsFieldAgentRetrieve.performsRetrieveData.user_id.first_name.toUpperCase() ? (
                <p>
                  {state.PerformsFieldAgentRetrieve.performsRetrieveData.user_id.first_name.toUpperCase()}
                </p>
              ) : (
                <p>{"---"}</p>
              )}
            </div>
            <div className="ROLE">
              <div className="LOGO">
                {state.PerformsFieldAgentRetrieve.performsRetrieveData !=
                  undefined &&
                state.PerformsFieldAgentRetrieve.performsRetrieveData.user_id !=
                  undefined &&
                state.PerformsFieldAgentRetrieve.performsRetrieveData.user_id !=
                  null &&
                state.PerformsFieldAgentRetrieve.performsRetrieveData.user_id
                  .user_role.role ? (
                  <h4>
                    {
                      state.PerformsFieldAgentRetrieve.performsRetrieveData
                        .user_id.user_role.role
                    }
                  </h4>
                ) : (
                  <h4>{"---"}</h4>
                )}
              </div>
            </div>
          </div>
        </div>

        {/* -----------Man---Power---performs=-------------------- */}
        <div
          className="row EmpPorfile ManPowerPerfomanceCards"
          style={{ paddingLeft: "55px", gap: "70px" }}
        >
          {state.PerformsFieldAgentRetrieve.performsRetrieveData != undefined &&
            state.PerformsFieldAgentRetrieve.performsRetrieveData
              .perform_types != undefined &&
            state.PerformsFieldAgentRetrieve.performsRetrieveData
              .perform_types != null &&
            state.PerformsFieldAgentRetrieve.performsRetrieveData.perform_types
              .perform_id != undefined &&
            state.PerformsFieldAgentRetrieve.performsRetrieveData.perform_types
              .perform_id != null &&
            state.PerformsFieldAgentRetrieve.performsRetrieveData.perform_types.perform_id.map(
              (item, index) => {
                const transformedGradingName = item.grading_name
                  .toLowerCase()
                  .replace(/\s+/g, "_")
                  .replace(/[^a-z0-9_]/g, "_");
                /// console.log(transformedGradingName, "transformedGradingName");
                return (
                  <div
                    className="col-md-3 Cards nav nav-tabs "
                    id="ex3-tab-1"
                    key={index}
                  >
                    <div className="card" style={{ height: "125px" }}>
                      <div
                        // className="card-body"
                        style={{ padding: "6px 16px " }}
                        className={`  card-body   ${
                          state.ManPowerActiveDataTabs.ActiveTabManPower ==
                          index
                            ? "active"
                            : ""
                        }`}
                        onClick={(e) => {
                          HandleManPowerfunction(item, index);
                          // navigate("/manpowerapply");
                          // navigate("/manpowerapply");
                        }}
                      >
                        <div className="WIthPendingStatus">
                          <h5 style={{ width: "80%" }}>{item.grading_name}</h5>

                          <div className="ICONS">
                            {state.PerformsFieldAgentRetrieve
                              .performsRetrieveData != undefined &&
                              state.PerformsFieldAgentRetrieve
                                .performsRetrieveData != null &&
                              state.PerformsFieldAgentRetrieve
                                .performsRetrieveData.perform_answer !=
                                undefined &&
                              state.PerformsFieldAgentRetrieve
                                .performsRetrieveData.perform_answer != null &&
                              Object.keys(
                                state.PerformsFieldAgentRetrieve
                                  .performsRetrieveData.perform_answer
                              ).map((innerKey, index) => {
                                const value =
                                  state.PerformsFieldAgentRetrieve
                                    .performsRetrieveData.perform_answer[
                                    innerKey
                                  ];

                                // console.log(
                                //   item.grading_name
                                //     .toLowerCase()
                                //     .replace(/\s+/g, "_")
                                //     .replace(/[^a-z0-9_]/g, "_") === innerKey,
                                //   "asdbasbfiuwasd"
                                // );
                                // Log values for debugging
                                // console.log(value, "value");
                                // console.log("innerKey", innerKey);
                                return (
                                  <React.Fragment key={index}>
                                    {/* Check if value is an object */}
                                    {typeof value === "object" &&
                                    item.grading_name
                                      .toLowerCase()
                                      .replace(/\s+/g, "_")
                                      .replace(/[^a-z0-9_]/g, "_") ===
                                      innerKey ? (
                                      <img
                                        src={
                                          // Use ternary operator to determine correct icon source
                                          item.grading_name
                                            .toLowerCase()
                                            .replace(/\s+/g, "_")
                                            .replace(/[^a-z0-9_]/g, "_") ===
                                            innerKey && value != null
                                            ? correctIcons
                                            : Pending
                                        }
                                      />
                                    ) : null}
                                  </React.Fragment>
                                );
                              })}

                            {/* {state.PerformsFieldAgentRetrieve
                              .performsRetrieveData != undefined &&
                              (state.PerformsFieldAgentRetrieve
                                .performsRetrieveData !=
                                null && state.PerformsFieldAgentRetrieve.performsRetrieveData.perform_answer) !=
                                null &&
                              state.PerformsFieldAgentRetrieve
                                .performsRetrieveData.perform_answer !=
                                undefined &&
                              Object.keys(
                                state.PerformsFieldAgentRetrieve
                                  .performsRetrieveData.perform_answer
                              ).map((innerKey, index) => {
                                const value =
                                  state.PerformsFieldAgentRetrieve
                                    .performsRetrieveData.perform_answer[
                                    innerKey
                                  ];
                                console.log(innerKey, "jhfsjdshd", value);
                                return (
                                  <>
                                    {value != null &&
                                    value != undefined &&
                                    typeof value === "object"
                                      ? Object.entries(value).map(
                                          ([subkey, subvalue], index) => {
                                            console.log(
                                              subkey,
                                              subvalue,
                                              index,
                                              "asdgasd"
                                            );
                                            return (
                                              <>
                                                {item.grading_name
                                                  .toLowerCase()
                                                  .replace(/\s+/g, "_")
                                                  .replace(
                                                    /[^a-z0-9_]/g,
                                                    "_"
                                                  ) === innerKey && subvalue ? (
                                                  // <img
                                                  //   src={
                                                  //     item.grading_name
                                                  //       .toLowerCase()
                                                  //       .replace(/\s+/g, "_")
                                                  //       .replace(
                                                  //         /[^a-z0-9_]/g,
                                                  //         "_"
                                                  //       ) === innerKey && subvalue
                                                  //       ? correctIcons
                                                  //       : Pending
                                                  //   }
                                                  // />
                                                  <img
                                                    src={
                                                      state
                                                        .PerformsFieldAgentRetrieve
                                                        .performsRetrieveData ==
                                                        undefined &&
                                                      state
                                                        .PerformsFieldAgentRetrieve
                                                        .performsRetrieveData ==
                                                        null &&
                                                      state
                                                        .PerformsFieldAgentRetrieve
                                                        .performsRetrieveData
                                                        .perform_answer ==
                                                        undefined &&
                                                      state
                                                        .PerformsFieldAgentRetrieve
                                                        .performsRetrieveData
                                                        .perform_answer == null
                                                        ? emptycircle
                                                        : state
                                                            .PerformsFieldAgentRetrieve
                                                            .performsRetrieveData
                                                            .perform_answer ==
                                                          null
                                                        ? Pending
                                                        : item.grading_name
                                                            .toLowerCase()
                                                            .replace(
                                                              /\s+/g,
                                                              "_"
                                                            )
                                                            .replace(
                                                              /[^a-z0-9_]/g,
                                                              "_"
                                                            ) === innerKey &&
                                                          subvalue
                                                        ? correctIcons
                                                        : Pending
                                                    }
                                                  />
                                                ) : null}
                                              </>
                                            );
                                          }
                                        )
                                      : null}
                                  </>
                                );
                              })} */}

                            <img src={ArrowIcons} />
                          </div>
                        </div>
                        <p style={{ padding: "30px", width: "100%" }}>
                          <span style={{ color: "black" }}>Total Points :</span>{" "}
                          {item.total_points}
                        </p>
                      </div>
                    </div>
                  </div>
                );
              }
            )}
        </div>

        <>
          {/* <div className="col-12 VerficationStatus">
                <span style={{ color: "#234492" }}>Approved Employee</span>
              </div> */}

          <>
            <div className="col-12 VerficationStatus">
              <button
                className="Decline ButtonCSS"
                onClick={(e) => {
                  HandleDecline(e);
                }}
              >
                Decline
              </button>

              {state.PerformsFieldAgentRetrieve.performsRetrieveData !=
                undefined &&
              state.PerformsFieldAgentRetrieve.performsRetrieveData != null &&
              state.PerformsFieldAgentRetrieve.performsRetrieveData
                .perform_answer != null &&
              state.PerformsFieldAgentRetrieve.performsRetrieveData
                .perform_answer != undefined &&
              state.PerformsFieldAgentRetrieve.performsRetrieveData
                .perform_answer.id != null &&
              state.PerformsFieldAgentRetrieve.performsRetrieveData
                .perform_answer.id != undefined &&
              state.PerformsFieldAgentRetrieve.performsRetrieveData
                .perform_answer.is_completed == true &&
              // state.PerformsFieldAgentRetrieve.performsRetrieveData
              //   .perform_answer.status != "" &&
              // state.PerformsFieldAgentRetrieve.performsRetrieveData
              //   .perform_answer.status != null &&
              
              state.PerformsFieldAgentRetrieve.performsRetrieveData
                .perform_answer.status != "approved" ? (
                <button
                  className="verify ButtonCSS"
                  onClick={(e) => {
                    HandleVerify(e);
                  }}
                >
                  Verify
                </button>
              ) : (
                <>
                  {state.PerformsFieldAgentRetrieve.performsRetrieveData !=
                    undefined &&
                  state.PerformsFieldAgentRetrieve.performsRetrieveData !=
                    null &&
                  state.PerformsFieldAgentRetrieve.performsRetrieveData
                    .perform_answer != null &&
                  state.PerformsFieldAgentRetrieve.performsRetrieveData
                    .perform_answer != undefined &&
                  state.PerformsFieldAgentRetrieve.performsRetrieveData
                    .perform_answer.id != null &&
                  state.PerformsFieldAgentRetrieve.performsRetrieveData
                    .perform_answer.id != undefined &&
                  state.PerformsFieldAgentRetrieve.performsRetrieveData
                    .perform_answer.status != undefined &&
                  state.PerformsFieldAgentRetrieve.performsRetrieveData
                    .perform_answer.status != null &&
                  state.PerformsFieldAgentRetrieve.performsRetrieveData
                    .perform_answer.status == "approved" ? (
                    <>
                      <div className="col-12 VerficationStatus">
                        <span style={{ color: "#234492" }}>
                          Approved employee
                        </span>
                      </div>
                    </>
                  ) : 
                  state.PerformsFieldAgentRetrieve.performsRetrieveData !=
                    undefined &&
                  state.PerformsFieldAgentRetrieve.performsRetrieveData !=
                    null &&
                  state.PerformsFieldAgentRetrieve.performsRetrieveData
                    .perform_answer != null &&
                  state.PerformsFieldAgentRetrieve.performsRetrieveData
                    .perform_answer != undefined &&
                  state.PerformsFieldAgentRetrieve.performsRetrieveData
                    .perform_answer.id != null &&
                  state.PerformsFieldAgentRetrieve.performsRetrieveData
                    .perform_answer.id != undefined &&
                  state.PerformsFieldAgentRetrieve.performsRetrieveData
                    .perform_answer.is_completed == true ? null : (
                    <div className="col-12 VerficationStatus">
                      <span style={{ color: "#234492" }}>
                        The employee is not approved from the app side
                      </span>
                    </div>
                  )}
                  

                  {/* ///----Approved--Employee----------------- */}
{/* 
                  {state.PerformsFieldAgentRetrieve.performsRetrieveData !=
                    undefined &&
                  state.PerformsFieldAgentRetrieve.performsRetrieveData !=
                    null &&
                  state.PerformsFieldAgentRetrieve.performsRetrieveData
                    .perform_answer != null &&
                  state.PerformsFieldAgentRetrieve.performsRetrieveData
                    .perform_answer != undefined &&
                  state.PerformsFieldAgentRetrieve.performsRetrieveData
                    .perform_answer.id != null &&
                  state.PerformsFieldAgentRetrieve.performsRetrieveData
                    .perform_answer.id != undefined &&
                    
                  state.PerformsFieldAgentRetrieve.performsRetrieveData
                    .perform_answer.is_completed == true ? null : (
                    <div className="col-12 VerficationStatus">
                      <span style={{ color: "#234492" }}>
                        The employee is not approved from the app side
                      </span>
                    </div>
                  )} */}


                </>
              )}
            </div>
          </>
        </>
      </div>
    </>
  );
};

export default ManPowerApply;
